"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;
var _Utils = require("../../../Utils");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
const Container = exports.Container = _styledComponents.default.ul(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    all: unset;\n    display: flex;\n    flex-direction: column;\n    height: auto;\n    transform-origin: top;\n\n    ", "\n"])), (0, _Utils.ifProp)('expanded', "\n        transform: scaleY(1);\n    ", "\n        max-height: 0px;\n        transform: scaleY(0);\n    "));